export default __webpack_public_path__ + "static/media/Träslöjd4.85b3e124.jpeg";